import { useState } from "react";
import { Link } from "react-router-dom";

function AccessHistory() {
    // const hide= "hidden";
    const users = [
        { id: 1, name: "Harold Ge Magsayo", role: "Master Admin", default_access: "Blocked", Added_on: "2024-06-01", added_access: "Active" },
        { id: 2, name: "Adrian Anasco", role: "Temporary Admin", default_access: "Active", Added_on: "2024-06-02", added_access: "Active" },
        { id: 3, name: "Mery Grace Lofranco", role: "Full Admin", default_access: "Pending", Added_on: "2024-06-03", added_access: "Inactive" },
        { id: 4, name: "Brandon Jacob", role: "Client", default_access: "Pending", Added_on: "2024-06-04", added_access: "Active" },
        { id: 5, name: "Brandon Jacob", role: "Employee", default_access: "Active", Added_on: "2024-06-05", added_access: "Active" },
        { id: 6, name: "Brandon Jacob", role: "Employee", default_access: "Active", Added_on: "2024-06-06", added_access: "Active" },
        { id: 7, name: "Brandon Jacob", role: "Employee", default_access: "Active", Added_on: "2024-06-07", added_access: "Active" },
        { id: 8, name: "Brandon Jacob", role: "Employee", default_access: "Active", Added_on: "2024-06-08", added_access: "Active" },
        { id: 9, name: "Brandon Jacob", role: "Employee", default_access: "Active", Added_on: "2024-06-09", added_access: "Active" },
        { id: 10, name: "Brandon Jacob", role: "Employee", default_access: "Active", Added_on: "2024-06-10", added_access: "Active" },
    ];
    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 5;
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentUsers = users.slice(indexOfFirstRow, indexOfLastRow);
    const totalPages = Math.ceil(users.length / rowsPerPage);
    return (
        <>
            <main id="main" className="main">
            <div className="pagetitle">
                <h1>Access History</h1>
                <nav>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <Link to="/">Home</Link>
                        </li>
                        <li className="breadcrumb-item">User Management</li>
                        <li className="breadcrumb-item active">Access History</li>
                    </ol>
                </nav>
            </div>

            <section className="section dashboard">
                <div className="row">
                    <div className="col-12">
                        <div className="card recent-sales overflow-auto">
                            <div className="card-body">

                                {/* Search Area */}
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h5 className="card-title m-0">Access History</h5>

                                    {/* Right side: Search + Add Button */}
                                    <div className="d-flex align-items-center gap-2">

                                        {/* Search */}
                                        <input
                                            type="text"
                                            className="form-control form-control-sm me-2"
                                            placeholder="Search user..."
                                            style={{ width: "200px" }}
                                        />
                                    </div>
                                </div>

                                {/* Table */}
                                <table className="table datatable">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Name</th>
                                            <th>Role</th>
                                            <th>Default Access</th>
                                            <th>Added Access</th>
                                            <th>Added On</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentUsers.map((user) => (
                                            <tr key={user.id}>
                                                <th>{user.id}</th>
                                                <td>{user.name}</td>
                                                <td className="text-primary">{user.role}</td>
                                                <td>{user.default_access}</td>
                                                <td>{user.added_access}</td>
                                                <td>{user.Added_on}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                <nav className="mt-3">
                                    <ul className="pagination justify-content-end">

                                        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                            <button
                                                className="page-link"
                                                onClick={() => setCurrentPage(currentPage - 1)}
                                            >
                                                Previous
                                            </button>
                                        </li>
                                        {[...Array(totalPages)].map((_, index) => (
                                            <li
                                                key={index}
                                                className={`page-item ${currentPage === index + 1 ? "active" : ""}`}
                                            >
                                                <button
                                                    className="page-link"
                                                    onClick={() => setCurrentPage(index + 1)}
                                                >
                                                    {index + 1}
                                                </button>
                                            </li>
                                        ))}
                                        <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                            <button
                                                className="page-link"
                                                onClick={() => setCurrentPage(currentPage + 1)}
                                            >
                                                Next
                                            </button>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
        </>
    )
}


export default AccessHistory